import {usePlacesWidget} from 'react-google-autocomplete'
import {useState} from 'react'
import Form from 'react-bootstrap/Form'

export default function LocationsFormControl({location, compact, onChange}) {
  const [selectedLocation, setSelectedLocation] = useState({
    formattedAddress: location?.formattedAddress,
    lat: location?.lat,
    lon: location?.lon
  })
  const onLocationSelect = (location) => {
    if(location) {
      const { lat, lng } = location?.geometry?.location
      const formattedAddress = location?.formatted_address

      setSelectedLocation({
        formattedAddress,
        lat: lat(),
        lon: lng(),
      })

      onChange({
        formattedAddress,
        lat: lat(),
        lon: lng()
      })
    } else {
      setSelectedLocation(null)
      onChange(null)
    }
  }

  const { ref } = usePlacesWidget({
    apiKey: process.env.NEXT_PUBLIC_GOOGLE_PLACES_AUTOCOMPLETE_API_KEY,
    onPlaceSelected: onLocationSelect,
    options: {
      types: ['(regions)'],
      componentRestrictions: {
        country: ['gb']
      }
    }
  })

  const handleChange = (event) => {
    const value = event.target.value
    if(value === '') {
      onLocationSelect(null)
    }
  }

  return (
    <Form.Control
      ref={ref}
      placeholder="Enter your location"
      defaultValue={selectedLocation?.formattedAddress}
      onChange={handleChange}
    />
  )
}
